<template>
  <div class="box-forgot">
    <h2 class="forgot-title">Password Recovery</h2>
    <p class="text-reset">
      We sent an email to <strong>{{customerEmail}}</strong> with instructions for reseting your password.
    </p>
    <a :href="link" class="btn-close">Close</a>
    <a href="https://dropsmarteo.com/support" class="support">Still having problems? Click here for more information.</a>
  </div>
</template>

<script>
export default {
  name: 'ResetFeedbackMessage',
  props: ["customerEmail", "here"],
  computed: {
    link: function() {
      return '/' + (this.here ? this.here : '');
    },
  }
};
</script>

<style lang="scss">
main {
  overflow-x: hidden;
  height: 100%;
}
.box-forgot {
  padding: 0 15px;
  text-align: center;
  .forgot-password {
    color: #666666;
    font-size: 13px;
    width: 100%;
  }
}
.support {
  font-size: 14px;
  text-align: center;
  display: block;
  margin: 35px 0 30px;
  &:hover {
    color: #79b867;
  }
}
.forgot-title {
  color: #000000;
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 0;
  text-align: center;
  text-transform: uppercase;
  width: 100%;
}
.text-reset {
  border: 1px solid #bfbfbf;
  color: #000000;
  font-size: 18px;
  margin: 0 auto;
  max-width: 415px;
  padding: 15px;
  text-align: center;
  margin: 30px 0;
}
.btn-close {
  border: 1px solid #46972e;
  border-radius: 50px;
  color: #46972e;
  display: block;
  font-size: 20px;
  line-height: 53px;
  margin-top: 8px;
  padding: 0 15px;
  text-transform: uppercase;
  width: 100%;
  &:hover {
    background-color: #46972e;
    color: #ffffff;
    text-decoration: none;
  }
}
</style>